export default __webpack_public_path__ + "static/media/lean-2-logo-alt2.ba103132.png";